export default "/images/bigLogo.dce08a05.png?dce08a058f4764c92af1ce15cc45085c";